var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home",staticStyle:{"text-align":"center"}},[_vm._v(" Looks like there was a problem, please contact support. "),_c('br'),_vm._v(" Reason: "+_vm._s(_vm.$route.query.reason)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }